import { StandardEvents } from '@shopify/events';

/**
 * Handles Horizon variant changes
 * for the custom vertical product gallery.
 */
function initVariantProductGalleries() {

  document
    .querySelectorAll('[data-vertical-product-gallery]')
    .forEach((gallery) => {

      if (gallery.dataset.variantListenerInitialized === 'true') {
        return;
      }

      gallery.dataset.variantListenerInitialized = 'true';

      const productSection =
        gallery.closest('.shopify-section, dialog');

      if (!productSection) return;

      productSection.addEventListener(
        StandardEvents.productSelect,
        (event) => {

          if (
            !(event.target instanceof Element) ||
            event.target.closest('product-card')
          ) {
            return;
          }

          if (!event.promise) return;

          event.promise
            .then(({ detail }) => {

              if (!detail?.html) return;

              const blockId =
                gallery.dataset.blockId;

              if (!blockId) return;

              /*
               * Ignore updates belonging
               * to another product.
               */
              if (
                detail.productId &&
                gallery.dataset.productId &&
                String(detail.productId) !==
                  String(gallery.dataset.productId)
              ) {
                return;
              }

              /*
               * Get the gallery Shopify rendered
               * for the newly selected variant.
               */
              const newGallery =
                detail.html.querySelector(
                  `variant-product-gallery[data-block-id="${blockId}"]`
                );

              if (!newGallery) return;

              /*
               * Replace the gallery contents.
               */
              gallery.innerHTML =
                newGallery.innerHTML;

              /*
               * Let the gallery's own JS know
               * that it needs to initialize again.
               */
              gallery.dispatchEvent(
                new CustomEvent(
                  'variant-gallery-rendered',
                  {
                    bubbles: true
                  }
                )
              );

            })

            .catch((error) => {

              if (error?.name !== 'AbortError') {
                console.warn(
                  '[variant-product-gallery]',
                  error
                );
              }

            });

        }
      );

    });

}

initVariantProductGalleries();